<template>
  <div>
    <div class="bg-white m-5 rounded-md shadow-lg">
      <div class="font-mono px-3 pt-3 font-bold text-right">Nº: {{ apuestaSeleccionada.secuencia }}</div>
      <div class="font-mono px-3 text-right text-sm">{{ format(parseISO(apuestaSeleccionada.fechaHora), "dd/MM/yyyy HH:mm:ss") }}</div>
      <div class="font-mono px-3 text-left">{{ apuestaSeleccionada.hipodromo }}</div>
      <div class="font-mono px-3 text-left">Carrera: {{ apuestaSeleccionada.numeroCarrera }}</div>
      <div class="font-mono px-3 text-left">{{ apuestaSeleccionada.cantidadVales }}v x {{ apuestaSeleccionada.tipo }} {{ apuestaSeleccionada.texto }}</div>
      <div class="font-mono px-3 text-right text-sm">Apuesta: {{ currency(apuestaSeleccionada.importe, { decimal: "," }).format() }}</div>
      <div class="font-mono px-3 text-right text-sm">Impuestos: {{ currency(apuestaSeleccionada.impuestos, { decimal: "," }).format() }}</div>
      <div class="font-mono px-3 text-right text-sm">Bonificacion: {{ currency(apuestaSeleccionada.bonificacion, { decimal: "," }).format() }}</div>
      <div class="font-mono px-3 text-right text-sm">Servicio: {{ currency(apuestaSeleccionada.servicio, { decimal: "," }).format() }}</div>
      <div class="font-mono px-3 text-right font-bold text-xl">Total: {{ currency(apuestaSeleccionada.total, { decimal: "," }).format() }}</div>
      <div class="font-mono px-3 text-left text-xs">P. Max(x$): {{ currency(apuestaSeleccionada.pagoMaximo, { decimal: "," }).format() }}</div>
    </div>
    <button v-if="apuestaSeleccionada.puedeAnular" @click="anular" class="bg-paleta-2 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Anular</button>
    <button @click="inicio" class="ml-2 bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Inicio</button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import currency from "currency.js";
import { parseISO, format } from "date-fns";

export default {
  data() {
    return {
      currency,
      parseISO,
      format
    };
  },
  methods: {
    anular() {
      this.$store.dispatch("anularApuesta", { id: this.apuestaSeleccionada.id });
    },
    inicio() {
      this.$router.push("/menu");
    }
  },
  computed: {
    ...mapState({
      apuestaSeleccionada: state => state.historial.apuestaSeleccionada
    })
  }
};
</script>
